__webpack_require__.p = "https://kontentino-web-app-dev5.dev-ec1.kontentino.dev/";